<!-- A standalone icon that can be hovered to show a tooltip -->
<template>
    <q-icon
        name="help_outline"
        class="on-right"
        size="18px"
    >
        <q-tooltip>
            <slot />
        </q-tooltip>
    </q-icon>
</template>
